var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import 'videojs-contrib-dash';
import * as React from 'react';
import { chunk, includes, uniq } from 'lodash';
import * as videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { connect } from 'react-redux';
import * as classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Mutation, Query } from 'react-apollo';
import purple from '@material-ui/core/colors/purple';
import { withStyles } from '@material-ui/core/styles';
import { Card, CircularProgress, Icon, IconButton } from '@material-ui/core';
import styles from './VideoPlayer.styles';
import { QueryS3Url } from './QueryS3Url';
import { getTranslation } from '../../translation';
import { langToVideoLinkPauseSoundMap, s3URLPrefix } from 'src/constants/common';
import { replaceTranslationSkipCharacters } from 'src/utils/common';
import { addUserAnalyticsVariables, addUserAnalyticsMutation } from '../../gql/addUserAnalytics';
import { getTranscodingStatusQuery } from '../../gql/getVideoTranscodingStatus';
import VideoPlayerSwitchContainer from './video/VideoPlayerSwitchContainer';
videojs.registerComponent('autoPlaySwitch', VideoPlayerSwitchContainer);
// @ts-ignore
var VideoPlayer = /** @class */ (function (_super) {
    __extends(VideoPlayer, _super);
    function VideoPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prevTime = 0;
        _this.interval = null;
        _this.soundAudio = null;
        _this.state = {
            showRibbon: true,
            videoErr: false,
            videoPlaying: false,
            isVideoPlayEnded: false,
            count: 0,
            fontSize: 14,
            currentBitrate: -1,
            subTitleLang: _this.props.subtitlesLang,
            subtitles: {
                enabled: true,
                language: _this.props.voiceOver &&
                    _this.props.voiceOver.length &&
                    _this.props.voiceOver.find(function (v) { return v.language === _this.props.language; })
                    ? _this.props.language
                    : _this.props.masterLanguage,
                current: 0,
                points: [],
            },
            // These events are used for showing video url link
            linkConfirmationToShow: null,
            shownChapterLinkIds: [],
        };
        _this.onLoadedData = function () {
            if (_this.props.onLoaded)
                _this.props.onLoaded();
            if (!_this.player.dash)
                return;
            _this.player.dash.mediaPlayer.seek(_this.player.duration() * 0.6);
            setTimeout(function () { return _this.player.dash.mediaPlayer.seek(0); }, 200);
            var bitrates = _this.player.dash.mediaPlayer.getBitrateInfoListFor('video');
            var bitrates_element_instance = videojs.getComponent('Component');
            var bitrates_element = new bitrates_element_instance(_this.player, {});
            bitrates_element.el().innerHTML = "\n      <div class=\"" + _this.props.classes.bitrates + "\">\n        <span>AUTO</span>\n        <div>\n          " + chunk(__spreadArray([{ bitrate: -1, height: -1, mediaType: '', qualityIndex: -1, scanType: null, width: 0 }], bitrates), 10)
                .map(function (currentChunk) {
                return "<div>\n                  " + currentChunk
                    .map(function (item) {
                    return "<span class=\"" + (item.bitrate === _this.state.currentBitrate ? 'active' : '') + "\" data-language=\"" + item.qualityIndex + "\">" + (item.height === -1 ? 'AUTO' : item.height + "P") + "</span>";
                })
                    .join(' ') + "\n                </div>";
            })
                .join(' ') + "\n        </div>\n      </div>\n    ";
            _this.player.getChild('controlBar').addChild(bitrates_element);
            Array.from(document.querySelectorAll("." + _this.props.classes.bitrates + " > div > div > span")).forEach(function (element) {
                element.addEventListener('click', _this.setBitrate);
            });
        };
        _this.onResizeDebounce = function () {
            clearTimeout(_this.resizeDebounce);
            if (!_this.player.el_)
                return;
            _this.resizeDebounce = setTimeout(function () { return _this.onResize(_this.player.el_.clientHeight, _this.player.aspectRatio_); }, 500);
        };
        _this.onEditorPlay = function () {
            if (_this.props.voiceOver && _this.props.voiceOver.length && !_this.state.subtitles.points.length) {
                _this.getSubtitlesPoints(_this.state.subtitles.language, _this.props.voiceOver);
            }
            if (!!_this.state.subTitleLang) {
                _this.setState({
                    subTitleLang: undefined,
                    subtitles: __assign(__assign({}, _this.state.subtitles), { enabled: true, language: _this.state.subTitleLang }),
                });
            }
            _this.setState({
                videoPlaying: true,
                isVideoPlayEnded: false,
                count: 0,
                showRibbon: false,
                videoErr: false,
            });
            if (_this.player.currentTime() * 1000 !== 0 && _this.playerInterval)
                return;
            _this.props.onPlaybackEvent('videoPlaybackStarted');
            var interval = 10 * 1000;
            _this.playerInterval = setInterval(function () {
                if (!_this.player || (_this.player && _this.prevTime === _this.player.currentTime() * 1000))
                    return;
                var time = _this.player.paused() ? _this.player.currentTime() * 1000 - _this.prevTime : interval;
                _this.props.onPlaybackEvent('videoTimeWatched', time * _this.player.playbackRate());
                _this.prevTime = _this.player.currentTime() * 1000;
            }, interval);
        };
        _this.onEditorEnd = function () {
            _this.setState({
                videoPlaying: false,
                isVideoPlayEnded: true,
                count: 0,
            });
            clearInterval(_this.playerInterval);
            _this.props.onPlaybackEvent('videoTimeWatched', _this.player.currentTime() * 1000 - _this.prevTime);
            _this.props.onPlaybackEvent('videoPlaybackEnded');
            _this.prevTime = 0;
            _this.props.onVideoPlaybackEnded();
        };
        _this.onEditorError = function () {
            if (_this.props.onLoaded)
                _this.props.onLoaded();
            _this.setState({ videoErr: true });
        };
        _this.onContextMenu = function (e) {
            e.preventDefault();
        };
        _this.setBitrate = function (_a) {
            var target = _a.target;
            var bitrates = _this.player.dash.mediaPlayer.getBitrateInfoListFor('video');
            var currentBitrate = Number(target.getAttribute('data-language'));
            var active = document.querySelector("." + _this.props.classes.bitrates + " .active");
            document.querySelector("." + _this.props.classes.bitrates + " > span").textContent =
                currentBitrate === -1 ? 'AUTO' : bitrates.find(function (b) { return b.qualityIndex === currentBitrate; }).height + "P";
            if (Boolean(active))
                active.classList.remove('active');
            target.classList.add('active');
            if (currentBitrate === -1) {
                _this.player.dash.mediaPlayer.setAutoSwitchQualityFor('video', true);
            }
            else {
                _this.player.dash.mediaPlayer.setAutoSwitchQualityFor('video', false);
                _this.player.dash.mediaPlayer.setQualityFor('video', currentBitrate);
            }
            _this.setState({ currentBitrate: currentBitrate });
        };
        _this.setSubtitlesLanguage = function (_a) {
            var target = _a.target;
            var active = document.querySelector("." + _this.props.classes.subtitles + " .active");
            if (Boolean(active))
                active.classList.remove('active');
            target.classList.add('active');
            _this.setState({
                subtitles: __assign(__assign({}, _this.state.subtitles), { enabled: true, language: target.getAttribute('data-language') }),
            });
        };
        _this.getChaptersFromLanguage = function (language, object) {
            return object.length
                ? (object.find(function (transcript) { return transcript.language === language && Boolean(transcript.chapters.length); }) || {
                    chapters: [],
                }).chapters
                : [];
        };
        _this.getSubtitlesLanguages = function (object) {
            if (object === void 0) { object = []; }
            return object.map(function (object) { return object.language; });
        };
        _this.getSubtitlesPoints = function (language, object) {
            if (language && object) {
                _this.setState({
                    subtitles: __assign(__assign({}, _this.state.subtitles), { points: _this.getChaptersFromLanguage(language, object).map(function (item) { return item.start; }) }),
                });
            }
        };
        _this.enableSubtitles = function (_a) {
            var target = _a.target;
            _this.state.subtitles && document.querySelector("." + _this.props.classes.subtitles + " .active")
                ? document.querySelector("." + _this.props.classes.subtitles + " .active").classList.remove('active')
                : null;
            _this.setState(function (_a) {
                var subtitles = _a.subtitles;
                return ({
                    subtitles: __assign(__assign({}, subtitles), { enabled: !subtitles.enabled }),
                });
            });
        };
        _this.onPlayerTimeUpdate = function () {
            _this.setState(function (_a) {
                var subtitles = _a.subtitles;
                var currentTime = _this.player.currentTime() * 1000;
                var currentIndex = subtitles.points.findIndex(function (point) { return point > currentTime; });
                var lastChapterTime = subtitles.points[subtitles.points.length - 1];
                if (!_this.props.isVideoLinksFeatureEnabled) {
                    return {
                        subtitles: __assign(__assign({}, subtitles), { current: currentIndex !== -1
                                ? currentIndex - 1
                                : lastChapterTime < _this.player.currentTime() * 1000
                                    ? subtitles.points.length - 1
                                    : -1 }),
                        linkConfirmationToShow: null,
                        shownChapterLinkIds: [],
                    };
                }
                var _b = (_this.props.links || []).reduce(function (acc, item, index) {
                    var nextItem = _this.props.links[index + 1];
                    var nextStart = nextItem ? nextItem.start : _this.player.duration() * 1000;
                    // 200 is added as tolerance so that, it doesnot exceed move to the new chapter before showing the link
                    if (currentTime >= nextStart - 200) {
                        return __assign(__assign({}, acc), { start: nextStart, prevChapterStart: _this.props.links[index].start });
                    }
                    return acc;
                }, { start: 0, prevChapterStart: 0 }), prevChapterStart = _b.prevChapterStart, start = _b.start;
                var currentLinkToShow = _this.props.links
                    ? __spreadArray([], _this.props.links).find(function (item) { return item.start === prevChapterStart; })
                    : { start: 0, link: { url: '' } };
                var nextLink = _this.props.links
                    ? __spreadArray([], _this.props.links).find(function (item) { return item.start === start; }) || _this.props.links[_this.props.links.length - 1]
                    : { start: 0, link: { url: '' } };
                var doesCurrentChapterContainLink = includes(_this.state.shownChapterLinkIds, currentLinkToShow ? currentLinkToShow.start : 0);
                var canShowLink = !doesCurrentChapterContainLink &&
                    currentLinkToShow &&
                    nextLink.start !== 0 &&
                    !!currentLinkToShow.link &&
                    !!currentLinkToShow.link.url;
                if (canShowLink) {
                    _this.soundAudio.play();
                    _this.player.pause();
                }
                return {
                    subtitles: __assign(__assign({}, subtitles), { current: currentIndex !== -1
                            ? currentIndex - 1
                            : lastChapterTime < _this.player.currentTime() * 1000
                                ? subtitles.points.length - 1
                                : -1 }),
                    linkConfirmationToShow: canShowLink ? currentLinkToShow : _this.state.linkConfirmationToShow,
                    shownChapterLinkIds: uniq(__spreadArray(__spreadArray([], _this.state.shownChapterLinkIds), [currentLinkToShow ? currentLinkToShow.start : 0])),
                };
            });
        };
        return _this;
    }
    VideoPlayer.prototype.componentDidMount = function () {
        var _this = this;
        var lang = this.props.language;
        this.soundAudio = new Audio(s3URLPrefix + ("" + (langToVideoLinkPauseSoundMap[lang] || langToVideoLinkPauseSoundMap['en-us'])));
        // instantiate Video.js
        this.player = videojs(this.videoNode, {
            autoplay: this.props.disableAutoPlay ? false : this.props.autoPlay,
            controls: true,
            fluid: true,
            aspectRatio: '16:9',
            poster: this.props.thumbnail,
            sources: [
                {
                    src: this.props.source,
                    type: this.props.source &&
                        this.props.source
                            .split('&')[0]
                            .split('.')
                            .pop() === 'mpd'
                        ? 'application/dash+xml'
                        : 'video/mp4',
                },
            ],
        });
        this.player.on('loadeddata', this.onLoadedData);
        this.player.on('play', this.onEditorPlay);
        this.player.on('ended', this.onEditorEnd);
        this.player.on('error', this.onEditorError);
        this.player.on('timeupdate', this.onPlayerTimeUpdate);
        this.onResize(this.player.el_.clientHeight, this.player.aspectRatio_);
        window.addEventListener('resize', this.onResizeDebounce);
        if (this.props.voiceOver && this.props.voiceOver.length) {
            var subtitles_element_instance = videojs.getComponent('Component');
            var subtitles_element = new subtitles_element_instance(this.player, {});
            subtitles_element.el().innerHTML = "\n        <div class=\"" + this.props.classes.subtitles + "\">\n          <span>CC</span>\n          </div>\n          <div>\n            " + chunk(this.getSubtitlesLanguages(this.props.voiceOver), 10)
                .map(function (currentChunk) {
                return "<div>\n                    " + currentChunk
                    .map(function (item) {
                    return "<span class=\"" + (item === _this.state.subtitles.language ? 'active' : '') + "\" data-language=\"" + item + "\">" + item + "</span>";
                })
                    .join(' ') + "\n                  </div>";
            })
                .join(' ') + "\n          </div>\n        </div>\n      ";
            this.player.getChild('controlBar').addChild(subtitles_element);
            document.querySelector("." + this.props.classes.subtitles + " > span").addEventListener('click', this.enableSubtitles);
            Array.from(document.querySelectorAll("." + this.props.classes.subtitles + " > div > div > span")).forEach(function (element) {
                element.addEventListener('click', _this.setSubtitlesLanguage);
            });
        }
        if (this.props.showTTLogo) {
            var ttLogoInstance = videojs.getComponent('Component');
            var ttLogo = new ttLogoInstance(this.player, {});
            ttLogo.el().innerHTML = "\n      <div>\n      <img class=\"" + this.props.classes.ttLogo + " \"src=\"./assets/images/tt-logo-white.png\"/>\n      </div>\n      ";
            this.player
                .getChild('controlBar')
                .addChild(ttLogo)
                .addClass('vjs-order-2');
        }
        if (!this.props.isEmbedVideo) {
            this.player.getChild('controlBar').addChild('autoPlaySwitch', {});
        }
    };
    // destroy player on unmount
    VideoPlayer.prototype.componentWillUnmount = function () {
        var _this = this;
        clearInterval(this.playerInterval);
        if (this.player) {
            this.player.off('loadeddata', this.onLoadedData);
            this.player.off('start', this.onEditorPlay);
            this.player.off('ended', this.onEditorEnd);
            this.player.off('error', this.onEditorError);
            this.player.on('timeupdate', this.onPlayerTimeUpdate);
            this.soundAudio.pause();
            var enableSubtitlesDOM = document.querySelector("." + this.props.classes.subtitles + " > span");
            var setSubtitlesLanguageDOM = document.querySelectorAll("." + this.props.classes.subtitles + " > div > span");
            if (enableSubtitlesDOM) {
                enableSubtitlesDOM.removeEventListener('click', this.enableSubtitles);
            }
            if (setSubtitlesLanguageDOM) {
                Array.from(document.querySelectorAll("." + this.props.classes.subtitles + " > div > span")).forEach(function (element) {
                    element.removeEventListener('click', _this.setSubtitlesLanguage);
                });
            }
            window.removeEventListener('resize', this.onResizeDebounce);
            this.player.dispose();
        }
    };
    VideoPlayer.prototype.onResize = function (height, ratio) {
        var _a = ratio.split(':'), x = _a[0], y = _a[1];
        this.setState({
            fontSize: ((Number(y) / Number(x)) * height) / 12,
        });
    };
    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
    VideoPlayer.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, translate = _a.translate, voiceOver = _a.voiceOver, videoDuration = _a.videoDuration, history = _a.history, trackItems = _a.trackItems, videoId = _a.videoId, autoPlay = _a.autoPlay;
        var _b = this.state, videoErr = _b.videoErr, subtitles = _b.subtitles, linkConfirmationToShow = _b.linkConfirmationToShow, videoPlaying = _b.videoPlaying, isVideoPlayEnded = _b.isVideoPlayEnded;
        var chapters = voiceOver ? this.getChaptersFromLanguage(subtitles.language, voiceOver) : [];
        var currentVideoIndex = !!trackItems && !!trackItems.length && videoId ? trackItems.findIndex(function (video) { return video.videoId === videoId; }) : null;
        var nextVideo = currentVideoIndex === 0 || !!currentVideoIndex ? trackItems[currentVideoIndex + 1] : null;
        var showNextThumbnail = isVideoPlayEnded && !!nextVideo && !!nextVideo.videoId;
        var elemId = document.getElementById('video-container');
        var clientWidth = elemId ? elemId.clientWidth : null;
        // Font size is calculated based on the size of the video container
        var fontSize = clientWidth ? (clientWidth > 1000 ? clientWidth / 55 : clientWidth / 48) : 16;
        if (showNextThumbnail && !this.interval && autoPlay) {
            this.interval = setInterval(function () {
                // Autoplay after 8 seconds
                if (_this.state.count > 80) {
                    clearInterval(_this.interval);
                    _this.interval = null;
                    history && history.push("/video/" + nextVideo.humanId + "?autoPlay=true");
                }
                else {
                    _this.setState({ count: _this.state.count + 1 });
                }
            }, 100);
        }
        var onCompleteLinkPage = function () {
            clearInterval(_this.interval);
            _this.interval = null;
            _this.setState({ linkConfirmationToShow: null, count: 0 });
            var currentTime = _this.player.currentTime() * 1000;
            if (currentTime !== _this.player.duration() * 1000) {
                _this.soundAudio.pause();
                _this.player.play();
            }
        };
        if (linkConfirmationToShow && !this.interval) {
            this.interval = setInterval(function () {
                // Autoplay after 8 seconds
                if (_this.state.count > 80) {
                    onCompleteLinkPage();
                }
                else {
                    _this.setState({ count: _this.state.count + 1 });
                }
            }, 100);
        }
        return (React.createElement("div", { className: classes.videoWrapper },
            React.createElement("div", { "data-vjs-player": true, onContextMenu: this.onContextMenu },
                !linkConfirmationToShow && showNextThumbnail && autoPlay && (React.createElement("div", { id: "video-container", style: { fontSize: fontSize, background: 'rgba(0, 0, 0, 0.54)' }, className: classes.videoEndWrapper },
                    React.createElement("div", { className: classes.titleText }, translate('up-next')),
                    React.createElement("div", { className: classes.nextVideoName }, replaceTranslationSkipCharacters(nextVideo.name)),
                    React.createElement("div", { className: classes.nextChannelName }, nextVideo.channelName),
                    React.createElement(Link, { className: classes.nextVideoLink, to: "/video/" + nextVideo.humanId + "?autoPlay=true" },
                        React.createElement(CircularProgress, { variant: "static", className: classes.loadingIcon, 
                            // Since the interval of auto play is 8 secs. And the progress bar takes values from (0-100) scale (0-80) to (0-100). Additional 0.05 is added so that the progress bar is stuck at 100 for a short time
                            value: this.state.count + 0.25 * this.state.count, style: { color: 'white' }, thickness: 3 }),
                        React.createElement(IconButton, { id: "play-video", className: classes.nextVideoPlayBtn },
                            React.createElement(Icon, { className: classes.nextPlayIcon }, "skip_next"))),
                    React.createElement("div", { onClick: function () {
                            _this.setState({ isVideoPlayEnded: false, count: 0 });
                            clearInterval(_this.interval);
                            _this.interval = null;
                        }, className: classes.cancelBtn },
                        React.createElement("span", { className: classes.cancelText },
                            " ",
                            translate('playback-cancel'))))),
                linkConfirmationToShow && (React.createElement("div", { style: { fontSize: fontSize, background: 'rgba(0, 0, 0, 0.54)' }, className: classes.videoEndWrapper },
                    React.createElement("div", { className: classes.titleText, style: { textTransform: 'uppercase', textAlign: 'center' } }, translate('related-link')),
                    React.createElement("div", { className: classnames(classes.linkTitle), style: { margin: '20px auto', textAlign: 'center' } }, linkConfirmationToShow.link.title),
                    React.createElement("div", { onClick: function () { return onCompleteLinkPage(); }, style: { textAlign: 'center' } },
                        React.createElement(CircularProgress, { variant: "static", className: classes.loadingIcon, 
                            // Since the interval of auto play is 8 secs. And the progress bar takes values from (0-100) scale (0-80) to (0-100). Additional 0.05 is added so that the progress bar is stuck at 100 for a short time
                            value: this.state.count + 0.25 * this.state.count, style: { color: 'white' }, thickness: 3 }),
                        React.createElement(IconButton, { id: "play-video", className: classes.nextVideoPlayBtn },
                            React.createElement(Icon, { className: classes.nextPlayIcon }, "skip_next"))),
                    React.createElement("div", { className: '', style: { marginBottom: 15, textAlign: 'center', marginTop: 30 } },
                        React.createElement("a", { href: linkConfirmationToShow.link.url, target: "_blank", className: classnames(classes.link, classes.cancelText), style: { cursor: 'pointer' } }, translate('open-link'))))),
                this.state.showRibbon && videoDuration && (React.createElement("div", { className: classes.videoDuration, style: { backgroundColor: 'black', opacity: 0.8 } }, videoDuration)),
                React.createElement("video", { "data-setup": '{ "playbackRates": [0.7, 1, 1.5, 2] }', ref: function (node) { return (_this.videoNode = node); }, style: { opacity: showNextThumbnail ? 0.3 : 1 }, className: "video-js vjs-big-play-centered h-full w-full" }),
                chapters.length && videoPlaying && subtitles.enabled && chapters[subtitles.current] && (React.createElement("div", { className: classes.transcript, style: { fontSize: this.state.fontSize } }, chapters[subtitles.current].manuscript))),
            videoErr && (React.createElement(Card, { className: classes.errorCard }, navigator.platform === 'iPhone' ? translate('ios-video-error') : translate('video-player-error')))));
    };
    VideoPlayer = __decorate([
        withStyles(styles),
        connect(function (state, ownProps) { return (__assign(__assign({}, ownProps), { translate: getTranslation(state.translation.lang), autoPlay: state.auth.user.settings.autoPlay, language: ownProps.mainLanguage || state.translation.lang })); })
    ], VideoPlayer);
    return VideoPlayer;
}(React.PureComponent));
export { VideoPlayer };
// @ts-ignore
var VideoPlayerWithLoader = /** @class */ (function (_super) {
    __extends(VideoPlayerWithLoader, _super);
    function VideoPlayerWithLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoPlayerWithLoader.prototype.componentWillUnmount = function () {
        if (this.stopPolling) {
            this.stopPolling();
        }
    };
    VideoPlayerWithLoader.prototype.renderVideo = function (thumbnail) {
        var _this = this;
        return (React.createElement(Mutation, __assign({}, addUserAnalyticsMutation()), function (addUserAnalyticsReq) { return (React.createElement(QueryS3Url, { source: _this.props.source }, function (_a) {
            var loading = _a.loading, error = _a.error, url = _a.url;
            if (loading) {
                return React.createElement("p", null, _this.props.translate('loading'));
            }
            if (error) {
                return React.createElement("p", null, error.message);
            }
            if (!_this.props.source && _this.props.fetchTranscodingStatus) {
                return (React.createElement(Query, __assign({}, getTranscodingStatusQuery(_this.props.videoId)), function (_a) {
                    var error = _a.error, data = _a.data, stopPolling = _a.stopPolling;
                    _this.stopPolling = stopPolling;
                    if (error) {
                        return React.createElement("p", null, error.message);
                    }
                    var transcodingStatus = data && data.transcodingStatus && data.transcodingStatus.length
                        ? data.transcodingStatus
                            .filter(function (t) { return t.language === _this.props.lang && t.version === _this.props.lastVersion; })
                            .slice(-1)[0]
                        : null;
                    var status = transcodingStatus ? transcodingStatus.status : '';
                    if (_this.lastStatus !== 'completed' && status === 'completed' && _this.props.refetchVideo) {
                        _this.props.refetchVideo(status);
                    }
                    _this.lastStatus = status;
                    if (_this.props.showLoadingStatus) {
                        return (React.createElement("div", { style: {
                                paddingTop: '22%',
                                paddingBottom: '22%',
                                fontSize: 20,
                            } },
                            React.createElement("p", { style: { textAlign: 'center' } }, _this.props.translate('video-player-error'))));
                    }
                    return (React.createElement("div", { style: {
                            paddingTop: '22%',
                            paddingBottom: '22%',
                            fontSize: 20,
                        } }, !data || !data.transcodingStatus || !data.transcodingStatus.length || !status ? (React.createElement("p", { style: { textAlign: 'center' } }, _this.props.translate('video-player-error'))) : (React.createElement(React.Fragment, null,
                        React.createElement(CircularProgress, { style: { color: _this.props.tubeColor || purple[500] }, thickness: 7 }),
                        React.createElement("p", null,
                            _this.props.translate('transcoding'),
                            ": ",
                            _this.props.translate(status))))));
                }));
            }
            return (React.createElement(VideoPlayer, { source: url, voiceOver: _this.props.subtitles, ribbonType: _this.props.ribbonType, thumbnail: thumbnail, subtitlesLang: _this.props.subtitlesLang, showTTLogo: _this.props.showTTLogo, isEmbedVideo: _this.props.isEmbedVideo, onLoaded: _this.props.onLoaded, shouldAutoPlay: _this.props.autoPlay, disableAutoPlay: _this.props.disableAutoPlay, linkedUrl: _this.props.linkedUrl, videoId: _this.props.videoId, mainLanguage: _this.props.mainLanguage, history: _this.props.history, links: _this.props.links, isVideoLinksFeatureEnabled: _this.props.isVideoLinksFeatureEnabled, videoDuration: _this.props.videoDuration, tubeColor: _this.props.tubeColor, trackItems: _this.props.trackItems, masterLanguage: _this.props.masterLanguage, onPlaybackEvent: function (event, time) {
                    if (_this.props.videoId) {
                        addUserAnalyticsReq(addUserAnalyticsVariables({
                            type: event,
                            payload: event === 'videoTimeWatched'
                                ? {
                                    videoId: _this.props.videoId,
                                    time: time,
                                    version: _this.props.lastVersion,
                                    lang: _this.props.lang,
                                }
                                : {
                                    videoId: _this.props.videoId,
                                    version: _this.props.lastVersion,
                                    lang: _this.props.lang,
                                },
                        }, _this.props.skipRefetch));
                    }
                }, onVideoPlaybackEnded: _this.props.onVideoPlaybackEnded }));
        })); }));
    };
    VideoPlayerWithLoader.prototype.getThumbnailAndRenderVideo = function () {
        var _this = this;
        return (React.createElement(QueryS3Url, { source: this.props.thumbnail }, function (_a) {
            var loading = _a.loading, error = _a.error, url = _a.url;
            if (loading) {
                return React.createElement("p", null, "Loading video...");
            }
            if (error) {
                return React.createElement("p", null, error.message);
            }
            return _this.renderVideo(url);
        }));
    };
    VideoPlayerWithLoader.prototype.render = function () {
        return this.props.thumbnail ? this.getThumbnailAndRenderVideo() : this.renderVideo();
    };
    VideoPlayerWithLoader = __decorate([
        connect(function (state, ownProps) { return (__assign(__assign({}, ownProps), { choosenLang: state.translation.lang, autoPlay: state.auth.user.settings.autoPlay, translate: getTranslation(state.translation.lang) })); })
    ], VideoPlayerWithLoader);
    return VideoPlayerWithLoader;
}(React.PureComponent));
export { VideoPlayerWithLoader };



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/VideoPlayer.tsx
// module id = 441
// module chunks = 81